<template>
  <div v-if="text">
    <div class="view-wrap" @click="toggleTextVisibility">
      <i class="el-icon-view" />
      <i v-show="!showText" :style="style" class="el-icon-minus" />
    </div>
    <span>{{ maskedText || '-' }}</span>
  </div>
</template>

<script>
import { decryptByDES } from '@/utils/crypto'
export default {
  name: 'HideableText',
  props: {
    text: {
      validator: function(value) {
        return typeof value === 'string' || typeof value === 'number' || value === null
      },
      required: true,
      default: '',
    },
    // 加密后的 text
    desText: {
      validator: function(value) {
        return typeof value === 'string' || typeof value === 'number' || value === null
      },
      required: true,
      default: '',
    },
    size: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      showText: false,
    }
  },
  computed: {
    style() {
      if (this.size == 12) {
        return {
          top: 0,
        }
      }
      return null
    },
    maskedText() {
      if (this.showText) {
        return decryptByDES(this.desText)
      } else {
        return this.text
      }
    },
  },
  methods: {
    toggleTextVisibility() {
      this.showText = !this.showText
    },
  },
}
</script>

<style lang="scss" scoped>
.view-wrap {
    display: inline-block;
    margin-right: 5px;
    position: relative;
    cursor: pointer;

    .el-icon-minus {
        position: absolute;
        text-shadow: 0.5px 0.5px 0 #ffffff, -0.5px -0.5px 0 #ffffff, 0.5px -0.5px 0 #ffffff, -0.5px 0.5px 0 #ffffff, 0.5px 0.5px 0 #ffffff, -0.5px -0.5px 0 #ffffff, 0.5px -0.5px 0 #ffffff, -0.5px 0.5px 0 #ffffff;
        transform: scale(1.4) rotate(135deg);
        top: 4px;
        left: -1px;
    }
}
</style>
